module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan1-3-3a15b4779e96d0798f967bd87bf532e0.webp";